module.exports = __webpack_public_path__ + "media/images/footer_page/claims/claims-15cc191ff8150619e753d960adf584dd.svg";